import script from "./PandyTransferItemDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PandyTransferItemDialog.vue?vue&type=script&setup=true&lang=js"

import "./PandyTransferItemDialog.vue?vue&type=style&index=0&id=45b34d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b34d68"]])

export default __exports__